module.exports = __webpack_public_path__ + "static/media/033-dental implant.b4d651aa.svg";